// extracted by mini-css-extract-plugin
export default {"iconSuccess":"qBNqL","success-icon":"XUrx8","savePersonalDataBtn":"HH_22"};